import React, {useState} from 'react';
import {Box, Button, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography,} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {UI} from "./form/FormUiKit";
import TableHeader from "../layout/table/TableHeader";
import NoDataLabel from "../layout/NoDataLabel";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ModalDelete from "../layout/ModalDelete";
import {useNavigate} from "react-router-dom";
import Constants from "../../../utils/constants";
import './FormsTable.css'
import {helper} from "../../../utils/helper.js";
import BadgeTypeLavage from "../layout/BadgeTypeLavage.js";
import TypologieLavageBadge from "../layout/TypologieLavageBadge.js";

function FormsTable({forms, ...props}) {
    const navigate = useNavigate()
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('client');
    const [label, setLabel] = useState("")
    const [objectToDelete, setObjectToDelete] = useState(null)
    const [open, setOpen] = useState(false);
    const [currentForm, setCurrentForm] = useState(null);

    // Table head cells
    const headCells = [
        {id: 'client', label: 'Client'},
        {id: 'libelle', label: 'Libellé'},
        {id: 'type', label: 'Typologie'},
        {id: 'actes', label: 'Actes complémentaires'},
        {id: 'options', label: 'Galerie / Relevé'},
        {id: 'lavagePartiel', label: 'Lavage partiel'},
    ];


    const openDeleteConfirmModal = (f) => {
        setCurrentForm(f)
        setLabel("Etes vous sûr de vouloir supprimer le formulaire : ")
        setObjectToDelete(f.libelle)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentForm(null)
    };

    const handleEditClick = (id) => {
        navigate(Constants.APP_ROUTE_ADMIN_FORMS_EDIT.replace(':id', id))
    }

    const handleDelete = () => {
        props.onDelete(currentForm)
        handleClose()
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const getItemComparator = (item, comparator) => {
        switch (comparator) {
            case 'client':
                return item.client?.libelle ?? '';
            case 'type':
                return item.typologieLavage?.libelle ?? '';
            case 'actes':
                return getActesComplementaires(item).length;
            case 'options':
                return (item.galleryEnabled ? 1 : 0) + (item.releveTerrainEnabled ? 1 : 0);
            case 'lavagePartiel':
                return hasLavagePartiel(item) ? 1 : 0;
            default:
                return item[comparator];
        }
    }
    const sortedData = () => {
        return forms.sort((a, b) => {
            if (order === 'asc') {
                return (getItemComparator(a, orderBy) > getItemComparator(b, orderBy)) ? 1 : (getItemComparator(b, orderBy) > getItemComparator(a, orderBy)) ? -1 : 0;
            }
            return (getItemComparator(a, orderBy) < getItemComparator(b, orderBy)) ? 1 : (getItemComparator(b, orderBy) < getItemComparator(a, orderBy)) ? -1 : 0
        });
    }

    // Actes complémentaires = tous les FormActe hors acte principal LAVAGE, triés par ordre.
    const getActesComplementaires = (form) => {
        return (form.formActes || [])
            .filter((fa) => fa.acte?.nature !== "LAVAGE")
            .sort((a, b) => (a.ordre || 0) - (b.ordre || 0));
    }

    // strategieLavageImpossible : enum sérialisé en int (0 = aucune, 1 = lavage partiel).
    const hasLavagePartiel = (form) => {
        return Number(form.strategieLavageImpossible) >= 1;
    }

    const NoneLabel = () => (
        <Typography variant="body2" sx={{color: UI.textMuted}}>—</Typography>
    );

    return (
        <React.Fragment>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="forms table" size="small">
                    <TableHeader headCells={headCells} order={order} orderBy={orderBy}
                                 onRequestSort={handleRequestSort}/>
                    <TableBody>
                        {forms && forms.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={7} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucun formulaire enregistré"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {forms && sortedData().map((form) => {
                            const actesComplementaires = getActesComplementaires(form);
                            return (
                                <React.Fragment key={form.id}>
                                    <TableRow hover onClick={() => handleEditClick(form.id)}
                                              style={{cursor: 'pointer'}}>
                                        <TableCell>
                                            {form.client?.libelle}
                                        </TableCell>
                                        <TableCell>
                                            {form.libelle}
                                        </TableCell>
                                        <TableCell>
                                            <TypologieLavageBadge typologie={form.typologieLavage}/>
                                        </TableCell>
                                        <TableCell>
                                            {actesComplementaires.length === 0
                                                ? <NoneLabel/>
                                                : <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                                    {actesComplementaires.map((fa) => (
                                                        <Chip
                                                            key={fa.id}
                                                            size="small"
                                                            label={fa.acte?.libelleFr}
                                                            variant={fa.obligatoire ? "filled" : "outlined"}
                                                            sx={fa.obligatoire
                                                                ? {bgcolor: UI.numBg, color: UI.navy, fontWeight: 600}
                                                                : {color: UI.textSoft, borderColor: UI.fieldBorder}}
                                                        />
                                                    ))}
                                                </Box>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {!form.galleryEnabled && !form.releveTerrainEnabled
                                                ? <NoneLabel/>
                                                : <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                                    {form.galleryEnabled &&
                                                        <Chip size="small" label="Galerie"
                                                              sx={{bgcolor: UI.numBg, color: UI.navy, fontWeight: 600}}/>
                                                    }
                                                    {form.releveTerrainEnabled &&
                                                        <Chip size="small" label="Relevé"
                                                              sx={{bgcolor: UI.numBg, color: UI.navy, fontWeight: 600}}/>
                                                    }
                                                </Box>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {hasLavagePartiel(form)
                                                ? <Chip size="small" label="Activé"
                                                        sx={{bgcolor: UI.greenLight, color: UI.navy, fontWeight: 600}}/>
                                                : <NoneLabel/>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <Grid container justify={"flex-end"} spacing={2}>
                                                <Grid item>
                                                    <Button color="secondary" size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleEditClick(form.id)
                                                            }}
                                                            startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                                        Editer
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button color="error" size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openDeleteConfirmModal(form)
                                                            }}
                                                            startIcon={<CloseOutlinedIcon/>}>
                                                        Supprimer
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <ModalDelete label={label} onClose={handleClose} open={open} objectToDelete={objectToDelete}
                         selectedValue={currentForm} onDelete={handleDelete}/>
        </React.Fragment>
    )
}

export default FormsTable;
